import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Field, formValueSelector, reduxForm, reset, change } from 'redux-form';
import { deleteStaffDetails, getMasterData, getStaffsList, showUsersSubMenus, UpdateStaffActiveStatus, UpdateStaffLockStatus } from './actions/UserActions';
import Alert from 'react-s-alert';
import history from '../../history';
import { renderAutoCompleteMultipleSelection, renderAutoCompleteSingleSelect, renderTextField, renderToggleButton, renderCheckBox } from './../../components/reduxFields';
import PaginatorCustom from './../../components/paginationCustom';
import SortingCustom from '../../components/SortingCustom';
import { resetFiltersAndSorting, showFormatedDate, base64Encode, alertConfirmation } from '../../actions/utilAction';
import { CommonButton } from '../../../src/components/buttons';
import StaffInternalNotesModal from './User/StaffInternalNotes_Modal';
import SchedulerLocked_Modal from './User/SchedulerLocked_Modal';

class ManageUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      users: [],
      includedData: [],
      activeToggleValues: [],
      lockToggleValues: [],
      masterTags: null,
      masterRoles: [],
      userTags: '',
      meta_data: null,
      ShowStaffOfAllLocations: false,
      ShowInactiveUsersOnly: false,
      openInternalNotesModal: false,
      StaffId: null,
      isExcludeTag: false,
      allClientTag: [],
      displaySelectedWithTags: false,
      openSchedulerLockModal: false,
      StaffName: '',
      schedulerLockedDate: null,
    };

    this.filter = {
      sort_Column: 'id',
      sort_Order: 'desc',
      searchText: '',
      roleID: '',
    };

    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.handleSearchUserName = this.handleSearchUserName.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
    this.onActiveToggle = this.onActiveToggle.bind(this);
    this.onLockToggle = this.onLockToggle.bind(this);
    this.handleOpenSchedulerLockClick = this.handleOpenSchedulerLockClick.bind(this);
    this.closeAndResetDialog = this.closeAndResetDialog.bind(this);
  }

  componentWillMount() {
    this.loadData();
    // let searchObj = {
    //   filters: { TypeKey: 'ALL_STAFF,BOTH' },
    // };
    // this.props.getUserMasterTags(searchObj);
    this.props.getMasterData('masterLocation,MASTERROLES,MASTERTAGSFORSTAFF');
    this.props.showUsersSubMenus(false);
  }

  loadData(page_number) {
    let searchObj = {
      contain_filters: {
        Tags: this.state.masterTags ? this.state.masterTags : null,
        LocationIDs: this.state.ShowStaffOfAllLocations ? '0' : this.props.currentLocationId ? this.props.currentLocationId : '0',
        searchkey: this.filter.searchText ? this.filter.searchText : undefined,
        RoleIds: this.filter.roleID ? this.filter.roleID : null,
        ShowInactiveUsersOnly: this.state.ShowInactiveUsersOnly ? '1' : '0',
        isExcludeTag: this.state.isExcludeTag ? true : false,
        displaySelectedStaffWithTags: this.state.displaySelectedWithTags ? true : false
      },
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_Order || 'desc',
      pageNumber: page_number || 1,
      isExcludeTag: this.state.isExcludeTag ? true : false,
      displaySelectedStaffWithTags: this.state.displaySelectedWithTags ? true : false
    };
    this.props.getStaffsList(searchObj);
  }

  componentWillReceiveProps = (nextProps) => {
    //this.props.showUsersSubMenus(true);
    if (nextProps.staffsList && nextProps.staffsList !== this.props.staffsList) {
      let meta_data = nextProps.staffsList.meta;
      let usersArray = nextProps.staffsList.data;
      this.setState({ users: usersArray, meta_data: meta_data });
      let activeToggleValues = new Array(usersArray.length).fill({});
      let lockToggleValues = new Array(usersArray.length).fill({});
      let index = 0;
      let lockIndex = 0;
      usersArray.map((obj) => {

        if (activeToggleValues.indexOf(obj) === -1) {
          activeToggleValues.splice(index, 1, obj);
          index = index + 1;
        }
        return activeToggleValues;
      });
      usersArray.map((obj) => {

        if (lockToggleValues.indexOf(obj) === -1) {
          lockToggleValues.splice(lockIndex, 1, obj);
          lockIndex = lockIndex + 1;
        }
        return lockToggleValues;
      });
      this.setState({
        activeToggleValues: activeToggleValues,
        lockToggleValues: lockToggleValues,
      });
    }

    if (nextProps.deletedStaffDetails && nextProps.deletedStaffDetails !== this.props.deletedStaffDetails) {
      this.loadData();
    }
    if (nextProps.masterRoles) {
      this.setState({
        masterRoles: nextProps.masterRoles,
      });
    }

  }
  componentWillUnmount() {
    Alert.closeAll();
  }

  openDialog = () => {
    this.setState({ open: true });
    history.push('/user');
  }
  closeDialog = () => {
    this.setState({ open: false, openInternalNotesModal: false, openSchedulerLockModal: false });
  };

  closeAndResetDialog = () => {
    this.setState({ open: false, openInternalNotesModal: false, openSchedulerLockModal: false },()=>{
      this.loadData();
    });
  };

  handleSearchUserName(event) {
    // if (event.Username != undefined) {
    //   this.searchText = event.Username;
    //   let searchObj = {
    //     sort_fields: this.filter.sort_Column ? this.filter.sort_Column : '-id',
    //     contain_filters: { firstname: this.searchText },
    //     page_number: 1,
    //     includes: 'include=userroles',
    //   };
    //   this.props.getUserNameBySearchText(searchObj);
    // } else {
    //   this.searchText = '';
    //   this.loadData();
    // }
  }

  handleOpenInternalNotes = (event, obj) => {
    // console.log('event, staffId.........', obj)
    this.setState({ openInternalNotesModal: true, StaffId: obj.staffID });
  };

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadData();
    }
  }

  handleSearchChange(event) {
    if (event.target.value.length > 1) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  };
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ManageUsersForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.roleID = '';
    this.setState({
      open: false,
      users: [],
      includedData: [],
      activeToggleValues: [],
      lockToggleValues: [],
      masterTags: null,
      masterRoles: [],
      userTags: '',
      meta_data: null,
      ShowStaffOfAllLocations: false,
      ShowInactiveUsersOnly: false,
      isExcludeTag: false,
      allClientTag: [],
      displaySelectedWithTags: false
    }, () => {
      this.props.dispatch(change('ManageUsersForm', 'ExcludeTag', false));
      this.props.dispatch(change('ManageUsersForm', 'DisplaySelectedWithTags', false)); 
      // this.props.dispatch(change('ManageUsersForm', 'Name', ''));
      // this.props.dispatch(change('ManageUsersForm', 'tags', ''));
      // this.props.dispatch(change('ManageUsersForm', 'RoleID', ''));
      this.loadData();
    });
  };


  handleAlertClick = (event, userId) => {
    this.props.deleteStaffDetails(userId);
  };

  handleEditUser = (obj, e) => {
    let staffID = base64Encode(`${obj.staffID}`);
    history.push(`/user/${staffID}`);
  };

  onActiveToggle(e, index, obj) {    
    alertConfirmation((obj.isActive ? 'If this staff is a rendering provider you must change the rendering provider for their clients before making this staff inactive. Are you sure you want to continue' : 'Are you sure you want to change user\'s active status?'), {  
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleActiveAlertClick,
        // value: e.target.value,
        id: index,
        userID: obj.staffID,
      },
    });

  };
  onLockToggle(e, index, user) {
    alertConfirmation('Are you sure you want to change user\'s lock status?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleLockAlertClick,
        // value: e.target.value,
        id: index,
        userID: user.userID,
      },
    });

  };
  handleLockAlertClick = (event, index, userID) => {
    let lockToggleValues = this.state.lockToggleValues;
    lockToggleValues[index].isBlock = !lockToggleValues[index].isBlock;
    this.setState({
      lockToggleValues: lockToggleValues,
    });
    let locParam = this.props.currentLocationId ? this.props.currentLocationId : '0';
    this.props.UpdateStaffLockStatus(userID, this.state.lockToggleValues[index].isBlock, locParam);
    Alert.closeAll();
  };
  handleActiveAlertClick = (event, index, userID) => {
    let activeToggleValues = this.state.activeToggleValues;
    activeToggleValues[index].isActive = !activeToggleValues[index].isActive;
    this.setState({
      activeToggleValues: activeToggleValues,
    });
    let locParam = this.props.currentLocationId ? this.props.currentLocationId : '0';
    this.props.UpdateStaffActiveStatus(userID, this.state.activeToggleValues[index].isActive, locParam);
    Alert.closeAll();
  };
  handleNewRequest = (input, values, noContent, label, data) => {
    input.onChange(values);
    let searchTerm = '';
    let searchValues = [];
    let allClientTag = []
    if (data && data.length) {
      data.forEach((selectedData, i) => {
        searchValues.push(selectedData.value);
        allClientTag.push(selectedData.id)
      });
      searchTerm = searchValues.join(',');
      this.setState({ masterTags: searchTerm, allClientTag: allClientTag }, () => {
        if(data.length < 2) {
          this.setState({ displaySelectedWithTags: false, }, () => {            
            this.props.dispatch(change('ManageUsersForm', 'DisplaySelectedWithTags', false));        
            this.loadData();
          });          
        }
        else {
          this.loadData();
        }        
      });
    } else {
      this.setState({ masterTags: null, allClientTag: [], isExcludeTag: false, displaySelectedWithTags: false }, () => {
        this.props.dispatch(change('ManageUsersForm', 'ExcludeTag', false));
        this.props.dispatch(change('ManageUsersForm', 'DisplaySelectedWithTags', false));
        this.loadData();
      });
    }
  };
  handleSearchByRole = (input, obj) => {
    let roleid = obj.value;
    this.filter.roleID = roleid;
    this.loadData();


  };
  handleDeleteClick = (e, obj) => {
    alertConfirmation('Are you sure you want to delete this user?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.staffID,
      },
    });
  };

  handleOpenSchedulerLockClick = (event, obj) => {
    this.setState({ openSchedulerLockModal: true, StaffId: obj.staffID, StaffName: (obj.firstName + ' ' + obj.lastName), schedulerLockedDate: obj.schedulerLockedDate });
  };

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadData();
      });
  }

  handleViewClick=(obj, e) => {    
    let staffID = base64Encode(`${obj.staffID}`);
    history.push(`/user-profile/${staffID}`);    
  };

  renderData() {
    if (this.props.staffsList && this.props.staffsList.data && this.props.staffsList.data.length > 0) {
      return this.props.staffsList.data.map((obj, index) => {
        let isRoleAdmin = ((obj.roleName.toUpperCase()) === 'ADMIN'),
        isRoleAdminAndSupport = ((obj.roleName.toUpperCase()) === 'ADMIN' || (obj.roleName.toUpperCase()) === 'THERALYTICS SUPPORT' || (obj.roleName.toUpperCase()) === 'THERALYTICS SUPPORT TEAM'),
          isEditAction = this.props.updatePermission;
        if (isRoleAdmin && !this.props.hasDefaultAccess) {
          isEditAction = false;
        }
        return (
          <tr key={index}>
            <td>{`${obj.firstName} ${obj.lastName}`}</td>
            <td>{obj.userName || '-'}</td>
            <td>{obj.roleName || '-'}</td>
            <td>{obj.phoneNumber}</td>
            <td>{obj.doj ? showFormatedDate(obj.doj) : ''} </td>
            <td>{obj.schedulerLockedDate ? showFormatedDate(obj.schedulerLockedDate) : ''} </td>
            {/* <td className={data.IsActive === true ? 'greenfont' : 'redfont'}>{data.IsActive ? 'Active' : 'Inactive'}</td> */}
            <td >
              <Field className="no_margin"
                name="active_status"
                toggled={this.state.activeToggleValues[index] && this.state.activeToggleValues[index].isActive ? this.state.activeToggleValues[index].isActive : false}
                component={renderToggleButton}
                disabled={isRoleAdminAndSupport || (this.props.updatePermission ? false : true)}
                onChange={(e) => this.onActiveToggle(e, index, obj)}
              />
            </td>
            {/* <td ><NavLink to={`/staff-profile/${data.StaffID}`}> profile</NavLink></td> */}
            {this.props.lockPermission ?
              <td>
                <Field className="no_margin"
                  name="lock_status"
                  toggled={this.state.lockToggleValues[index] && this.state.lockToggleValues[index].isBlock ? this.state.lockToggleValues[index].isBlock : false}
                  component={renderToggleButton}
                  disabled={isRoleAdminAndSupport || (this.props.updatePermission ? false : true)}
                  onChange={(e) => this.onLockToggle(e, index, obj)}
                />
              </td>
              : null
            }

            {this.props.updatePermission || this.props.deletePermission || this.props.viewProfileSmryPermission ?
              <td>
                {this.props.viewProfileSmryPermission ?
                  <button onClick={this.handleViewClick.bind(this, obj)} type="button" title="View Profile" className="tbactionbtn yellowfont"><i className="fa fa-eye" aria-hidden="true"></i></button>
                  : null
                }
                {
                  isEditAction ?
                    <button onClick={(e) => this.handleOpenInternalNotes(e, obj)} type="button" title="Staff Internal Notes" className="tbactionbtn bluefont"><i className="fa fa-sticky-note-o" aria-hidden="true"></i></button>
                    : null
                }
                {
                  isEditAction ?
                    <button onClick={this.handleEditUser.bind(this, obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                    : null
                }
                {/* {
                  this.props.deletePermission && !isRoleAdmin ? (
                    <button onClick={(e) => this.handleDeleteClick(e, obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  )
                    : null
                } */}
                {
                  isEditAction ?
                    <button type="button" onClick={(e) => this.handleOpenSchedulerLockClick(e, obj)} title="Scheduler Lock" className="tbactionbtn bluefont"><i className="fa fa-lock" aria-hidden="true"></i></button>
                    : null
                }
              </td>
              : null
            }
          </tr>
        );
      });
    } else {
      return (<tr>
        <td colSpan='9' className="text-center no-record">{this.props.loading ? 'Loading, Please wait...' : 'No record found.'}</td>
      </tr>);
    }
  };

  isExcludeTagHandler = (e) => {
    if (e.target.checked) {
      this.setState({
        isExcludeTag: true,
        displaySelectedWithTags: false,
      }, () =>  {
       this.props.dispatch(change('ManageUsersForm', 'DisplaySelectedWithTags', false));      
       this.loadData()
      });
    }
    else {
      this.setState({
        isExcludeTag: false,
        displaySelectedWithTags: false,
      }, () =>  {
        this.props.dispatch(change('ManageUsersForm', 'DisplaySelectedWithTags', false));      
        this.loadData()
       });
    }    
  }

  isDisplaySelectedStaffWithTagsHandler = (e) => {
    if (e.target.checked) {
      this.setState({
        displaySelectedWithTags: true,
        isExcludeTag: false,
      },  () =>  {
        this.props.dispatch(change('ManageUsersForm', 'ExcludeTag', false));      
        this.loadData()
       });
    }
    else {
      this.setState({
        isExcludeTag: false,
        displaySelectedWithTags: false,
      },  () =>  {
        this.props.dispatch(change('ManageUsersForm', 'ExcludeTag', false));      
        this.loadData()
       });
    }
  }
  
  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        {this.state.openInternalNotesModal ? <StaffInternalNotesModal staffId={this.state.StaffId} closeDialog={this.closeDialog} /> : null}
        {this.state.openSchedulerLockModal ? <SchedulerLocked_Modal staffId={this.state.StaffId} schedulerLockedDate={this.state.schedulerLockedDate} staffName={this.state.StaffName} closeAndResetDialog={this.closeAndResetDialog} closeDialog={this.closeDialog}/> : null}
        <h2 className="page_title">Manage Users</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow userlist">
              <div className="row">
                <div className="col-sm-2">
                  {this.props.addPermission ?
                    <CommonButton name='add_user' label="Add User" primary={true} onTouchTap={this.openDialog} />
                    : null
                  }
                </div>
                <div className="col-sm-10">
                  <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchUserName)}>
                    <div className="row end-flex">
                      <div className="col-sm-4 field-mr">
                        <Field
                          name="ShowStaffOfAllLocations"
                          label="Include All Locations"
                          component={renderCheckBox}
                          onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowStaffOfAllLocations')}
                        />
                      </div>
                      <div className="col-sm-4 field-mr">
                        <Field
                          name="ShowInactiveUsersOnly"
                          label="Show Inactive Users Only"
                          component={renderCheckBox}
                          onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowInactiveUsersOnly')}
                        />
                      </div>                      
                      <div className="col-sm-4 mtm-27">
                        <Field
                          name="Name"
                          floatingLabelText="Search By Name"
                          maxLength="100"
                          fullWidth={true}
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2 field-mr">
                          <Field
                            name="RoleID"
                            label="Role"
                            handleNewRequest={this.handleSearchByRole}
                            options={this.state.masterRoles}
                            component={renderAutoCompleteSingleSelect} />
                        </div>
                        <div className="col-sm-3 field-mr">
                          <Field
                            name="tags"
                            label="Tags"
                            handleNewRequest={this.handleNewRequest}
                            options={this.props.masterTags}
                            component={renderAutoCompleteMultipleSelection} />
                        </div>
                        <div className="col-sm-2 field-mr">
                          {this.state.allClientTag.length > 0 && <Field
                            name="ExcludeTag"
                            label="Exclude Tag"
                            component={renderCheckBox}
                            onChange={(e) => this.isExcludeTagHandler(e)}
                          />}
                        </div>
                        <div className="col-sm-3 field-mr">
                          {this.state.allClientTag.length > 1  && <Field
                              name="DisplaySelectedWithTags"
                              label="Display Staff who have all of the selected tags."
                              component={renderCheckBox}
                              onChange={(e) => this.isDisplaySelectedStaffWithTagsHandler(e)}
                            />}
                        </div>
                        <div className="reset-btn col-sm-2 btn_rt">
                          <CommonButton className="grey_btn" name='reset' onTouchTap={this.handleResetButton} label='Reset' />
                        </div>
                      </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 mt-20">
                <div className="table-responsive">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="18%"><SortingCustom setSortColumn={this.setSortColumn} columnName='firstName' displayName='Name' /></th>
                        <th width="10%">User Name</th>
                        <th width="11%">Role</th>
                        <th width="10%">Phone</th>
                        <th width="12%"><SortingCustom setSortColumn={this.setSortColumn} columnName='doj' displayName='Date Joined' /></th>
                        <th width="20%"><SortingCustom setSortColumn={this.setSortColumn} columnName='schedulerLockedDate' displayName='Schedule Lock Date' /></th>
                        <th width="5%">Active</th>
                        {/* <th width = "5">Profile</th> */}
                        {this.props.lockPermission ?
                          <th width="5%">Lock User</th>
                          : null
                        }
                        {this.props.updatePermission || this.props.deletePermission || this.props.viewProfileSmryPermission ?
                          <th width="9%">Action</th>
                          : null
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderData()}
                    </tbody>
                  </table>
                </div>
                {this.props.staffsList && this.props.staffsList.meta ?
                  <PaginatorCustom data={this.props.staffsList.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const selectorUserTagForm = formValueSelector('ManageUsersForm');

function mapStateToProps(state) {
  let masterRoles = [],
    masterTagsforStaff = [];
  if (state.user.master_data) {
    masterRoles = state.user.master_data.masterRoles || [];
    masterTagsforStaff = state.user.master_data.masterTagsforStaff || [];
  };
  // Start For Role Permission
  let userScreenPermissionProfileSummary = [];
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'USER');
    userScreenPermissionProfileSummary = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);

    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'USER_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_LIST_DELETE')[0].permission : false;
  let lockPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_LIST_CHANGELOCK')[0].permission : false;

  let viewProfileSmryPermission = hasDefaultAccess ? true : userScreenPermissionProfileSummary && userScreenPermissionProfileSummary.filter((obj) => obj.screenKey === 'USER_PROFILE')[0] ? userScreenPermissionProfileSummary.filter((obj) => obj.screenKey === 'USER_PROFILE')[0].permission : false;
  // End For Role Permission
  return {
    // users: state.user.users_list,
    staffsList: state.user.staffs_list,
    deletedStaffDetails: state.user.deletedStaffDetails,
    loading: state.user.loading,
    masterTags: masterTagsforStaff,
    masterRoles: masterRoles,
    master_data: state.user.master_data,
    // searchTags_loading: state.user.searchTags_loading,
    deleted_user: state.user.deleted_user,
    activeUser: state.user.activeUser,
    currentLocationId: state.login.currentLocationId,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
    lockPermission: lockPermission,
    hasDefaultAccess: hasDefaultAccess,
    selectorUserTag: selectorUserTagForm(state, 'tags'),
    viewProfileSmryPermission: viewProfileSmryPermission,    
    staffLockStatus: state.user.staffLockStatus,
  };
}

ManageUsers = reduxForm({
  form: 'ManageUsersForm',
  enableReinitialize: true,
})(ManageUsers);

export default connect(mapStateToProps, { getStaffsList, deleteStaffDetails, getMasterData, UpdateStaffLockStatus, UpdateStaffActiveStatus, showUsersSubMenus })(ManageUsers);



// WEBPACK FOOTER //
// ./src/modules/users/index.js